var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 53,
    viewBox: "0 0 45 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3874 2.28711L1.48047 31.7671H20.2405L16.6674 50.5271L42.5736 21.0471H23.8136L27.3874 2.28711Z",
    fill: "#FF3D00",
    stroke: "#FF3D00",
    strokeWidth: 1.34,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.b48a71647499b3b128f8d667de83e8b4.svg";
export { ForwardRef as ReactComponent };